<p-fileUpload
  name="file"
  [url]="uploadUrl"
  multiple="false"
  accept=""
  maxFileSize="1000000"
  [chooseLabel]="chooseLabel"
  [uploadLabel]="uploadLabel"
  [cancelLabel]="cancelLabel"
  [maxFileSize]="1000000"
  showCancelButton="false"
  (onBeforeUpload)="onBeforeUpload($event)"
  (onUpload)="onUpload($event)"
  (onError)="onError($event)"
  (onClear)="onClear($event)"
  (onRemove)="onRemove($event)"
  (onSelect)="onSelect($event)"
>
</p-fileUpload>
